import create from 'zustand';
import { combine, devtools } from 'zustand/middleware';

const initialState = {
  isLogoModalOpen: false,
  isCoverModalOpen: false,
  isCoverCropperModalOpen: false,
  userInfo: {},
  coverExif: {},
  accountInfo: {
    impersonatorUsername: '',
  },
};

const store = combine(initialState, (set) => ({
  setCoverExif: (nextState: any) => {
    set(() => ({
      coverExif: nextState,
    }));
  },
}));

export const useStore = create(devtools(store));
